import React from "react";
import {
  ICON_MAPS,
  TRANSACTION_STATE,
  TRANSACTION_TABLE_ENTITY_TYPE_MAP,
  VIEW_ENTITY_TYPE,
} from "../../../services/RecentActivity/recentTransactions/recentTransaction.constants";
import {
  formatDateAndTime,
  formatMoney,
} from "../../../utils/helperFunctions";
import {
  getTransactionIcons,
  getTransactionTableEntityType,
  getTransactionType,
  getTxnState,
  getWithdrawTransactionStatus,
} from "../recentActivityHelper";
import parse from "html-react-parser";
import {
  accountOpeningCharge,
  deposit,
  withdraw,
} from "../../../assets/images/icons";
import "./transactionItem.scss";
import {
  isMobile,
  navigateToURL,
  triggerNavigation,
} from "../../../bridges/BridgeServices";
import { getPlatformForBot } from "../../Chatbot/ChatbotUtil";
import { getUrlConfig } from "../../../bridges/deeplinkUrlConfig";

const TransactionItem = ({
  item,
  onTransactionClick = () => {},
  lastItem = false,
}) => {
  const itemView =
    item.view.find(
      view => view.type !== VIEW_ENTITY_TYPE.SENT_PAYMENT
    ) || item.view[0];
  const transactionStatus = getWithdrawTransactionStatus(
    item.view.find(
      view => view.type === VIEW_ENTITY_TYPE.SENT_PAYMENT
    ) || item.view[0]
  );

  const getIcon = () => {
    let icon = getTransactionIcons(itemView);
    switch (icon) {
      case ICON_MAPS.ACC_OPENING_ICON:
        return accountOpeningCharge;
      case ICON_MAPS.DEPOSIT_ICON:
        return deposit;
      case ICON_MAPS.WITHDRAW_ICON:
        return withdraw;
      default:
        return deposit;
    }
  };

  const handleTransactionItemClick = () => {
    onTransactionClick?.();
    if (
      (itemView?.data?.globalTransactionId ||
        itemView.data?.globalPaymentId) &&
      itemView?.state
    ) {
      if (isMobile()) {
        navigateToURL("CHATBOT", {
          src: getTransactionType(itemView),
          txnId:
            itemView.data?.globalTransactionId ??
            itemView.data?.globalPaymentId,
          txnState: getTxnState(itemView.state),
          errorCode: itemView.data?.fulfilmentState,
          platform: getPlatformForBot(),
        });
      } else {
        const config = getUrlConfig({
          src: getTransactionType(itemView),
          txnId:
            itemView.data?.globalTransactionId ??
            itemView.data?.globalPaymentId,
          txnState: getTxnState(itemView.state),
          errorCode: itemView.data?.fulfilmentState,
          platform: getPlatformForBot(),
        })?.["RECENT_ACTIVITY"];
        const transIdUrl = config.webURL;
        triggerNavigation({
          deepLink: "",
          webURL: transIdUrl,
        });
      }
    }
  };

  return (
    <div
      className="transactionItem"
      onClick={handleTransactionItemClick}
    >
      <div className="iconContainer">
        {parse(getIcon())}
      </div>
      <div
        className={`rightContainer ${
          lastItem && "rightContainerNoBorder"
        }`}
      >
        <div className="typeContainer">
          <p className="entityType">
            {
              TRANSACTION_TABLE_ENTITY_TYPE_MAP[
                getTransactionTableEntityType(itemView)
              ]
            }
          </p>
          <p className="inactiveText">
            {formatDateAndTime(
              itemView?.updatedAt ?? itemView?.createdAt
            )}
          </p>
        </div>
        <div className="statusContainer">
          <p className="entityType">
            {VIEW_ENTITY_TYPE.SPONSOR_DEBIT_TRANSACTION ===
            itemView?.type
              ? "- "
              : VIEW_ENTITY_TYPE.SPONSOR_CREDIT_TRANSACTION ===
                itemView?.type
              ? "+ "
              : ""}
            {formatMoney(
              itemView?.data?.amount ||
                itemView?.data?.actualAmount ||
                itemView?.data?.requestedAmount
            )}
          </p>
          <p
            className={`inactiveText ${transactionStatus}`}
          >
            {itemView?.state ===
              TRANSACTION_STATE.COMPLETED &&
            !!itemView?.data?.requestedAmount &&
            itemView.data.requestedAmount !==
              itemView.data?.actualAmount ? (
              <span className="inactiveText">
                {formatMoney(
                  itemView.data?.requestedAmount
                )}
                {" requested"}
              </span>
            ) : (
              transactionStatus !==
                TRANSACTION_STATE.COMPLETED && (
                <span>{transactionStatus}</span>
              )
            )}
          </p>
        </div>
      </div>
    </div>
  );
};

export default TransactionItem;
